import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { PermissionViewCacheModule } from './view-cache.module';
import { permissionsFeatureKey, reducers } from './permission-controller/root';
import { EffectsModule } from '@ngrx/effects';
import { UserPermEffects } from './user-permissions-controller/effects/user-permissions.effects';
import { TeamPermEffects } from './team-permissions-controller/effects/team-permissions.effects';
import { RolePermEffects } from './role-permissions-controller/effects/role-permissions.effects';
import { PermSetEffects } from './perm-set-controller/effects/perm-set.effects';
import { ClientSidePermissionsEffects } from './client-side-permissions-controller/effects/client-side-permission.effects';
import { PermWizardEffects } from './permission-wizard-controller/effects/permission-wizard.effects';
import { UserPermInquiryEffects } from './user-permissions-inquiry-controller/effects/user-permissions-inquiry.effects';
import { RolePricingSchemeLinkPermissionsEffects } from './role-pricing-scheme-link-controler/effects/role-pricing-scheme-link.effects';

const EFFECTS = [
  UserPermEffects,
  TeamPermEffects,
  RolePermEffects,
  PermSetEffects,
  PermWizardEffects,
  ClientSidePermissionsEffects,
  UserPermInquiryEffects,
  RolePricingSchemeLinkPermissionsEffects,
];

export const permissionEffectsModule = EffectsModule.forFeature(EFFECTS);
export const permissionStoreModule = StoreModule.forFeature(permissionsFeatureKey, reducers);

@NgModule({
  imports: [
    CommonModule,
    PermissionViewCacheModule,
    permissionStoreModule,
    permissionEffectsModule
  ]
})

export class PermissionModule {}
